import { requestHandler } from "../lib/utils/network-client";

export function getTrusties(params = {}) {
  return requestHandler("/trusty", {
    params
  });
}

export function createTrusty(payload) {
  return requestHandler("/trusty", {
    method: "POST",
    body: payload
  });
}

export function updateTrusty(id, payload) {
  return requestHandler(`/trusty/${id}`, {
    method: "PUT",
    body: payload
  });
}

export function deleteTrusty(id) {
  return requestHandler(`/trusty/${id}`, {
    method: "DELETE"
  });
}

export function updateTrustyOrder(orderData) {
  return requestHandler("/trusty/set-order", {
    method: "PUT",
    body: { orderData }
  });
}

